"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const emptyTokenBalance = {
    id: '0x',
    token: {
        id: '0x',
        address: '0x',
        balanceScalar: '0',
    },
    account: '0x',
    value: '0',
    valueExact: '0',
};
class TokenBalance {
    constructor(data) {
        this.data = data;
        if (!data) {
            this.data = emptyTokenBalance;
        }
    }
    get token() {
        return this.data.token.id;
    }
    get scalar() {
        return new bignumber_js_1.BigNumber(this.data.token.balanceScalar);
    }
    get scaledBalance() {
        return new bignumber_js_1.BigNumber(this.data.value);
    }
    get balance() {
        return !this.scaledBalance.eq('0')
            ? this.scaledBalance.div(this.scalar)
            : new bignumber_js_1.BigNumber('0');
    }
}
exports.default = TokenBalance;
//# sourceMappingURL=TokenBalance.js.map